import { ComponentProps } from 'react'
import { webchatClasses } from '../styles/classes'
import { useTranslations } from '../contexts/TranslationContext'
import { X } from 'lucide-react'

type Props = ComponentProps<typeof X> & {
  onClick?: () => void
}

export const CloseWindowButton = ({ onClick, ...props }: Props) => {
  const { header } = webchatClasses
  const t = useTranslations()

  const onSelect = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    onClick?.()
  }
  return (
    <X
      {...props}
      {...header.content.actions.icons}
      role="button"
      tabIndex={0}
      aria-label={t['closeButton.ariaLabel']}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onSelect(e)
        }
      }}
    />
  )
}
